import React from 'react';
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import SignaturePad from 'signature_pad';
import label from "enqc-utilities/src/label/Label";
import {CgErase, MdCancel, MdUpdate} from 'react-icons/all';
import PropTypes from "prop-types";

export default class SignatureDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.canvasRef = React.createRef();
        this.sigPad = null;

        this.state = {
            modalShow: props.show
        };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            this.setState({ modalShow: true });
        }

        if (prevProps.show && !this.props.show) {
            this.setState({ modalShow: false });
        }
    }
    handleOpened = () => {
        this.initSignaturePad();
    };

    initSignaturePad = () => {
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        // 🔥 destroy previous instance (important)
        if (this.sigPad) {
            this.sigPad.off();
            this.sigPad = null;
        }

        // 🔥 FIX DPI + size (CRITICAL)
        const rect = canvas.getBoundingClientRect();
        const ratio = Math.max(window.devicePixelRatio || 1, 1);

        canvas.width = rect.width * ratio;
        canvas.height = rect.height * ratio;

        const ctx = canvas.getContext("2d");
        ctx.scale(ratio, ratio);

        // 🔥 init AFTER size is correct
        this.sigPad = new SignaturePad(canvas, {
            minWidth: 3.0,
            maxWidth: 5,
            throttle: 0,
            velocityFilterWeight: 0.1
        });

        // 🔥 force rebind events (IMPORTANT)
        this.sigPad.on();
    };

    clear = () => {
        this.sigPad?.clear();
    };

    save = () => {
        if (!this.sigPad || this.sigPad.isEmpty()) return;
        const dataUrl = this.sigPad.toDataURL("image/png");
        console.log("Signature:", dataUrl);
        this.props.callback?.(dataUrl);
    };

    render() {
        return (
            <Modal
                isOpen={this.state.modalShow}
                size="lg"
                centered
                onOpened={this.handleOpened} >
                <ModalHeader>{label.DigitalSignature}</ModalHeader>
                <ModalBody className="text-center">
                    <p className="text-muted fs-6">
                        {label.DrawYourDigitalSignatureBelow}
                    </p>

                    <div
                        className="shadow mx-auto mt-3"
                        style={{
                            width: 650,
                            height: 650,
                            position: "relative"
                        }}>
                        <canvas
                            ref={this.canvasRef}
                            style={{
                                width: "100%",
                                height: "100%",
                                touchAction: "none",
                                display: "block"
                            }}/>
                        {/* ✅ FLOATING BUTTON */}
                        <Button
                            onClick={this.clear}
                            className="btn-white-normal"
                            style={{
                                position: "absolute",
                                bottom: 10,
                                right: 10,
                                zIndex: 10
                            }}>
                            {label.Reset}&nbsp;<CgErase />
                        </Button>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup>
                        <Button className="btn-warning" onClick={e=>{
                            e.preventDefault()
                            if(this.props.cancelCallback){
                                this.props.cancelCallback()
                            }
                        }}>
                            {label.Cancel}&nbsp;<MdCancel/>
                        </Button>
                        <Button className="btn-soft-green" onClick={e=>{
                            e.preventDefault()
                            this.save()
                        }}>
                            {label.Update}&nbsp;<MdUpdate/>
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        );
    }
}
SignatureDrawer.propTypes = {
    show:PropTypes.bool,
    callback:PropTypes.func,
    cancelCallback:PropTypes.func,
}
